export const REST_ENDPOINTS = {
  UPLOAD: import.meta.env.VITE_BACKEND_URL + '/api/files/upload',
  CHATS: import.meta.env.VITE_BACKEND_URL + '/api/chats',
  VERSION: import.meta.env.VITE_BACKEND_URL + '/api/version',
  FEEDBACK: import.meta.env.VITE_BACKEND_URL + '/feedback',
  RESOURCES: import.meta.env.VITE_BACKEND_URL + '/api/resources',
  FAQ: import.meta.env.VITE_BACKEND_URL + '/api/help-center/faq',
  RELEASE_NOTES: import.meta.env.VITE_BACKEND_URL + '/api/help-center/release-notes',
  ME: import.meta.env.VITE_BACKEND_URL + '/api/me',
  EVENT: import.meta.env.VITE_BACKEND_URL + '/event',
};

export const WS_ENDPOINTS = {
  CHAT_STREAM: import.meta.env.VITE_WS_BASE_PATH + '/ws/chat',
};

export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  UNPROCESSABLE_ENTITY: 422,
  SERVER_ERROR: 500,
} as const;

export const MAX_RETRIES = 3;
export const RETRY_DELAY_MS = 1000;
export const REQUEST_TIMEOUT = 30000;

export const FEATURES = {
  UPLOAD_ATTACHMENTS: true,
};

export const APP_NAME = 'TalentIQ';

/**
 * sessionStorage key used to persist a deep-link path across the MSAL login
 * redirect round-trip.
 *
 * Written by _app.tsx beforeLoad when it redirects an unauthenticated request.
 * Read by InnerApp's useEffect (main.tsx) after MSAL finishes and
 * isAuthenticated transitions to true.
 */
export const AUTH_REDIRECT_KEY = 'auth_redirect_path';

/**
 * localStorage key holding the date (YYYY-MM-DD) of the newest release note the
 * user has seen. Used by the header indicator to badge unseen notes.
 */
export const RELEASE_NOTES_LAST_SEEN_KEY = 'release_notes_last_seen';

export const LOCALE = 'en-US';
